import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { BACKGROUND_LOADER, FONT_SIZE_LOADER, SIZE_LOADER, FAT_LOADER } from '../../globals';

import { StyledLoadingSpinner } from './styles/StyledLoadingSpinner';


class LoadingSpinner extends Component {
  render() {
    const { text, textSize, spinnerSize, backgroundColor, spinnerFat } = this.props;

    return (
      <StyledLoadingSpinner
        textSize={textSize} 
        spinnerSize={spinnerSize}
        spinnerFat={spinnerFat} 
        backgroundColor={backgroundColor}
      > 
        <div className="loader-container" role="status">
          <div className="loader-content">
            <div className="loader-spinner"></div>
            <div className="loader-text">
              { text }
            </div> 
          </div>  
        </div>      
      </StyledLoadingSpinner>
    );
  }
}


LoadingSpinner.propTypes = {
  text: PropTypes.string,
  textSize: PropTypes.number,
  spinnerSize: PropTypes.number,
  spinnerFat: PropTypes.number,
  backgroundColor: PropTypes.string,
};

LoadingSpinner.defaultProps = {
  textSize: FONT_SIZE_LOADER,
  spinnerSize: SIZE_LOADER,
  spinnerFat: FAT_LOADER,
  backgroundColor: BACKGROUND_LOADER
};

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./src/common/LoadingSpinner/LoadingSpinner.js